module.exports = __webpack_public_path__ + "img/london-office-4.ef75c6d5.jpg";